module.exports = __webpack_public_path__ + "img/Dantam Makeover 08.c6fa10a5.jpg";